import { useEffect, useState } from 'react';
import {fetchCountries}  from '../../services/magento/api'
import '../styles/ProductPage.css';

const StepAddress = ({ data, updateData, nextStep, setStepValidator }) => {
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);  

  const [formData, setFormData] = useState(
    {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      country_id: '',
      address1: '',
      address2: '',
      state: '',
      region_id: '',
      city: '',
      zipcode: '',
      ...data
    }
  );

  const [errors, setErrors] = useState({});

useEffect(() => {
  const allowedCountryCodes = ['US', 'MX', 'CA'];

  const load = async () => {
    const result = await fetchCountries();
    if (result) {
      const filtered = result.filter(country =>
        allowedCountryCodes.includes(country.id)
      );
      setCountries(filtered);
    }
  };

  load();
}, []);

  useEffect(() => {
    if (formData.country_id) {
      const country = countries.find(c => c.id === formData.country_id);
      setRegions(country?.available_regions || []);
    } else {
      setRegions([]);
    }
  }, [formData.country_id, countries]);


  useEffect(() => {
    setStepValidator(() => () => {
      const valid = validateForm();
      if (valid) updateData(formData);
      return valid;
    });
  }, [formData, setStepValidator]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'state') {
      const selectedRegion = regions.find(r => r.code === value);
      setFormData(prev => ({
        ...prev,
        state: value,
        region_id: selectedRegion?.id || ''
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };


  const validateForm = () => {
    const newErrors = {};

    if (!(formData.firstName || '').trim()) newErrors.firstName = 'First Name is required';
    if (!(formData.lastName || '').trim()) newErrors.lastName = 'Last Name is required';

    if (!(formData.email || '').trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!(formData.phone || '').trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^[\d\s\-()+]{10,}$/.test(formData.phone)) {
      newErrors.phone = 'Invalid phone number';
    }

    if (!formData.country_id) newErrors.country_id = 'Country is required';

    if (!(formData.address1 || '').trim()) newErrors.address1 = 'Address 1 is required';

    if (!(formData.state || '').trim()) newErrors.state = 'State is required';

    if (!(formData.city || '').trim()) newErrors.city = 'City is required';

    if (!(formData.zipcode || '').trim()) newErrors.zipcode = 'Zip Code is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      updateData(formData);
      nextStep();
    }
  };

  return (
    <div className="address-container">
      <div className="address-form-card">
        <h1>Shipping Information</h1>
        <p className="address-subtitle">
          Please provide your details so we can ship your gift
        </p>

        <form onSubmit={handleSubmit} noValidate>
          {/* First Name */}
          <div className="address-form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className={errors.firstName ? 'error' : ''}
              placeholder="John"
            />
            {errors.firstName && <span className="address-error-message">{errors.firstName}</span>}
          </div>

          {/* Last Name */}
          <div className="address-form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className={errors.lastName ? 'error' : ''}
              placeholder="Doe"
            />
            {errors.lastName && <span className="address-error-message">{errors.lastName}</span>}
          </div>

          {/* Email */}
          <div className="address-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
              placeholder="your@email.com"
            />
            {errors.email && <span className="address-error-message">{errors.email}</span>}
          </div>

          {/* Phone */}
          <div className="address-form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? 'error' : ''}
              placeholder="(123) 456-7890"
            />
            {errors.phone && <span className="address-error-message">{errors.phone}</span>}
          </div>

          {/* Country */}
          <div className="address-form-group">
            <label htmlFor="country_id">Country</label>
            <select
              id="country_id"
              name="country_id"
              value={formData.country_id}
              onChange={handleChange}
              className={errors.country_id ? 'error' : ''}
              required
            >
              <option value="" disabled>Select a country</option>
              {countries.map(country => (
                <option key={country.id} value={country.id}>
                  {country.full_name_locale || country.full_name_english}
                </option>
              ))}
            </select>
            {errors.country_id && <span className="address-error-message">{errors.country_id}</span>}
          </div>

          {/* Address 1 */}
          <div className="address-form-group">
            <label htmlFor="address1">Address 1</label>
            <input
              type="text"
              id="address1"
              name="address1"
              value={formData.address1}
              onChange={handleChange}
              className={errors.address1 ? 'error' : ''}
              placeholder="123 Main St"
            />
            {errors.address1 && <span className="address-error-message">{errors.address1}</span>}
          </div>

          {/* Address 2 */}
          <div className="address-form-group">
            <label htmlFor="address2">Address 2 (optional)</label>
            <input
              type="text"
              id="address2"
              name="address2"
              value={formData.address2}
              onChange={handleChange}
              placeholder="Apartment, suite, etc."
            />
          </div>

          {/* State */}
          <div className="address-form-group">
            <label htmlFor="state">State</label>
            <select
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              className={errors.state ? 'error' : ''}
            >
              <option value="">Select a state</option>
              {regions.map(({ code, name, id }) => (
                <option key={`${code}-${id}`} value={code}>
                  {name}
                </option>
              ))}
            </select>
            {errors.state && <span className="address-error-message">{errors.state}</span>}
          </div>

          {/* City */}
          <div className="address-form-group">
            <label htmlFor="city">City</label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className={errors.city ? 'error' : ''}
              placeholder="City"
            />
            {errors.city && <span className="address-error-message">{errors.city}</span>}
          </div>

          {/* Zipcode */}
          <div className="address-form-group">
            <label htmlFor="zipcode">Zip Code</label>
            <input
              type="text"
              id="zipcode"
              name="zipcode"
              value={formData.zipcode}
              onChange={handleChange}
              className={errors.zipcode ? 'error' : ''}
              placeholder="12345"
            />
            {errors.zipcode && <span className="address-error-message">{errors.zipcode}</span>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default StepAddress;
